// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3WnpE","options":"AnswerScale_options__l4hrt","selected":"AnswerScale_selected__U52aL"};